import type { ImportExportExportStep } from '@robovision/import-export'
import {
  buildImportExportStore,
  ImportExportStoreType,
} from './buildImportExportStore'


const useStore = buildImportExportStore<ImportExportExportStep>(ImportExportStoreType.Export)

export function useExportsStore () {
  const exportStore = useStore()

  return {
    addExport: exportStore.addItem,
    exports: exportStore.state,
    getExportProgress: exportStore.getProgress,
    getSubjectExports: exportStore.getItems,
    getUnexportedStepGroups: exportStore.getUnfinishedStepGroups,
    loadUnfinishedExports: exportStore.loadPersistedState,
    markExportPaused: exportStore.markPaused,
    markExportResumed: exportStore.markResumed,
    markExportStepCompleted: exportStore.markStepCompleted,
    removeExport: exportStore.removeItem,
    setStepProgress: exportStore.setStepProgress,
  }
}
